module.exports = __webpack_public_path__ + "media/800-5_SERF_2022_EmailRedFlags.41f35257.mp4";